import Field from './Field'

export default function FieldTree (label, key, items, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'tree'
  this.items = items
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldTree.js